import axiosInstance from "../Shared/Utils/axiosInstance";

export const getProfileDataFromServer = (selectedLanguageID) => {
  return axiosInstance.get(
    `/api/profile/getProfile?languageid=${selectedLanguageID}`
  );
};

export const UpdateProfileDataFromServer = async (data) => {
  return axiosInstance.put(`/api/profile/updateProfile`, data);
};

export const updateProfilePhotoToServer = async (formData) => {
  return await axiosInstance.post(`/image/upload`, formData);
};

export const deleteProfilePhotoFromServer = async () => {
  return await axiosInstance.delete(`/image/delete`);
};
